const blue = {
  500: '#3B58C1',
};

export { blue };
